import { api } from '@/lib/axios-client'
import type {
  Activity,
  DashboardCounts,
  Deadline,
  RecentProject,
} from '../types/dashboard-types'

export async function getDashboardCounts(
  cityKey: string,
): Promise<DashboardCounts> {
  const res = await api.get<DashboardCounts>(
    `/CityClerk/Dashboard/Counts?cityId=${cityKey}`,
  )
  return res
}

export async function getRecentProjects(
  cityKey: string,
  count: number,
): Promise<RecentProject[]> {
  const res = await api.get<RecentProject[]>(
    `/CityClerk/Dashboard/RecentProjects?cityId=${cityKey}&count=${count}`,
  )
  return res
}

export async function getUpcomingDeadlines(
  cityKey: string,
  count: number,
): Promise<Deadline[]> {
  const res = await api.get<Deadline[]>(
    `/CityClerk/Dashboard/UpcomingDeadlines?cityId=${cityKey}&count=${count}`,
  )
  return res
}

export async function getRecentActivities(
  cityKey: string,
  count: number,
): Promise<Activity[]> {
  const res = await api.get<Activity[]>(
    `/CityClerk/Dashboard/RecentActivities?cityId=${cityKey}&count=${count}`,
  )
  return res
}
